/**
 * The closed list of things a credential check covers, in a module of its own so that both
 * `notifications.ts` (the `credential` event's facts) and `credentials.ts` (the views) read it
 * without importing each other.
 */
export const CREDENTIAL_TARGET_TYPES = ["dataflow", "stage", "warehouse", "dbt_repo"] as const;
export type CredentialTargetType = (typeof CREDENTIAL_TARGET_TYPES)[number];
